import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { ConvertedContentHubArticle } from '@propertypal/shared/src/types/strapi/overrides';
import React from 'react';
import ContentHubArticleBox from '../content-hub/ContentHubArticleBox';
import { ContentHubCarouselContainer } from '../content-hub/ContentHubCarousel.style';
import { Rail } from '../home/LatestNews.style';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Box } from '../layout';
import { MidHeading } from '../typography';
import { BackToContainer, BackToLink } from './Article.style';
import { RelatedArticlesContainer } from './RelatedArticles.style';

interface RelatedArticlesProps {
  relatedArticles: ConvertedContentHubArticle[];
  backTo?: { title: string; url: string };
}

const RelatedArticles: React.FC<RelatedArticlesProps> = ({ relatedArticles, backTo }) => {
  return (
    <ContentHubCarouselContainer>
      <RelatedArticlesContainer>
        {relatedArticles?.length > 0 && (
          <Box>
            <MidHeading mb={30} fontSize={30}>
              Relevant Articles &amp; Guides
            </MidHeading>
            <Rail columns={3} data-testid="related-articles">
              {relatedArticles.map((article) => (
                <ContentHubArticleBox key={article.id} article={article} />
              ))}
            </Rail>
          </Box>
        )}
        {backTo && (
          <BackToContainer>
            <BackToLink prefetch={false} href={backTo.url} data-testid="back-to-link">
              <span>View more {backTo.title.toLowerCase()}</span>
              <FontAwesomeIcon icon={faChevronRight} size={13} />
            </BackToLink>
          </BackToContainer>
        )}
      </RelatedArticlesContainer>
    </ContentHubCarouselContainer>
  );
};

export default RelatedArticles;
